// extracted by mini-css-extract-plugin
export default {"wrapper":"DateRangePicker_wrapper__Z6FkP","shortcutTrigger":"DateRangePicker_shortcutTrigger__M80dw","sep":"DateRangePicker_sep__lH11Y"};